import { type Colors } from "@oreme/ui/lib/theme";
import { ThemeTypeEnum, ThemePalette } from "@/types";

const getThemePalette = (
  colors: Colors,
  theme: ThemeTypeEnum,
  value?: keyof ThemePalette,
): ThemePalette | string => {
  let palette;
  switch (theme) {
    case ThemeTypeEnum.BIODIVERSITY:
      palette = colors.green;
      break;
    case ThemeTypeEnum.WATER:
      palette = colors.cyan;
      break;
    case ThemeTypeEnum.EARTH:
      palette = colors.orange;
      break;
    case ThemeTypeEnum.UNIVERSE:
      palette = colors.violet;
      break;
  }
  if (value) return palette[value];
  return palette;
};

const getThemeColor = (theme: ThemeTypeEnum): string => {
  switch (theme) {
    case ThemeTypeEnum.BIODIVERSITY:
      return "green";
    case ThemeTypeEnum.WATER:
      return "cyan";
    case ThemeTypeEnum.EARTH:
      return "orange";
    case ThemeTypeEnum.UNIVERSE:
      return "violet";
  }
};

export { getThemePalette, getThemeColor };
